import { apiHolder, apis, } from 'api';
import { config } from 'env_def';
export const stage = config('stage');
const isWeb = config('build_for') === 'web';
export const host = isWeb ? '' : config('host');
export const diskApi = apiHolder.api.requireLogicalApi(apis.netStorageImpl);
export const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
export const templateApi = apiHolder.api.requireLogicalApi(apis.mailTemplateImplApi);
export const systemApi = apiHolder.api.getSystemApi();
export const docHost = config('docHost');
export const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
export const loggerApi = apiHolder.api.requireLogicalApi(apis.loggerApiImpl);
export const productApi = apiHolder.api.requireLogicalApi(apis.mailProductImplApi);
export const eventApi = apiHolder.api.getEventApi();
export const customerDiscoveryApi = process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG ? apiHolder.api.requireLogicalApi(apis.customerDiscoveryApi) : null;
export const roleApi = process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG ? apiHolder.api.requireLogicalApi(apis.edmRoleApiImpl) : null;
export const dataTrackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
export const errorReportApi = apiHolder.api.requireLogicalApi(apis.errorReportImpl);
export const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
export const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
export const httpApi = apiHolder.api.getDataTransApi();
export const getFileApi = () => {
    return apiHolder.api.getFileApi();
};
